import React, { useState } from 'react'
import { StContent } from './style.css'
import WordpressRawContent from '../../../components/WordpressRawContent'

const Content = ({ raw }) => {
  return (
    <StContent>
      <WordpressRawContent raw={raw} />
    </StContent>
  )
}

export default Content